import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FieldFormComponent } from '../field-form/fieldform.component';

@Component({
    selector: 'm4u-fielddetail',
    templateUrl: './fielddetail.component.html',
    styleUrls: ['./fielddetail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldDetailComponent extends FieldFormComponent {
    @Input() Icon: string;
    @Input() IsShowEmpty: boolean = false;
    @Input() Position: 'vertical' | 'horizontal' = 'vertical';
    @Input() ValueAlignment: 'start' | 'end' = 'start';
    @Input() Class: string;
    @Input() Value: string;

    get SaveHTML(){
        return this.sanitizer.bypassSecurityTrustHtml(this.Value);
    }
}